import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import './platformSetting.css';
import {
  apiCallGetAllAdminProcessingFees,
  apiCallToggleAdminProcessingFeeStatus,
  apiCallUpdateAdminProcessingFee,
  apiCallAddAdminProcessingFee,
} from "../../Core/Apicall";

import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../Config/Actions/loadingActions";

import EmptyData from "../../Components/EmptyData/EmptyData";

import Colors from "../../Constants/Colors";
import Icons from "../../Constants/Icons";
import Header from "../../Components/Header/Header";

const PlatformSetting = () => {

  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.isLoading);

  const [processingFeeList, setProcessingFeeList] = useState([]);

  const [addEditModal, setAddEditModal] = useState(false);

  const [isEdit, setIsEdit] = useState(false);

  const [selectedFee, setSelectedFee] = useState(null);

  const [formData, setFormData] = useState({
    feeName: "",
    feeType: "fixed",
    feeValue: "",
    currency: "USD",
    description: "",
  });

  // GET ALL PROCESSING FEES
  const fetchProcessingFeeList = async () => {

    dispatch(setLoadingTrue());

    try {

      const response = await apiCallGetAllAdminProcessingFees();

      setProcessingFeeList(response?.data || []);

    } catch (error) {

      console.log("fetchProcessingFeeList Error :", error);

    } finally {

      dispatch(setLoadingFalse());
    }
  };

  // ACTIVE / INACTIVE
  const handleToggleStatus = async (item) => {

    dispatch(setLoadingTrue());

    try {

      const param = {
        processingFeeId: item?._id,
      };

      await apiCallToggleAdminProcessingFeeStatus(param);

      fetchProcessingFeeList();

    } catch (error) {

      console.log("handleToggleStatus Error :", error);

    } finally {

      dispatch(setLoadingFalse());
    }
  };

  // OPEN ADD MODAL
  const handleAddClick = () => {

    setIsEdit(false);

    setSelectedFee(null);

    setFormData({
      feeName: "",
      feeType: "fixed",
      feeValue: "",
      currency: "USD",
      description: "",
    });

    setAddEditModal(true);
  };

  // OPEN EDIT MODAL
  const handleEditClick = (item) => {

    setIsEdit(true);

    setSelectedFee(item);

    setFormData({
      feeName: item?.feeName || "",
      feeType: item?.feeType || "fixed",
      feeValue: item?.feeValue || "",
      currency: item?.currency || "USD",
      description: item?.description || "",
    });

    setAddEditModal(true);
  };

  // HANDLE INPUT CHANGE
  const handleInputChange = (e) => {

    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ADD / UPDATE API
  const handleSubmit = async () => {

    if (!formData?.feeName) {
      alert("Please enter fee name");
      return;
    }

    if (!formData?.feeValue) {
      alert("Please enter fee value");
      return;
    }

    dispatch(setLoadingTrue());

    try {

      if (isEdit) {

        const param = {
          processingFeeId: selectedFee?._id,
          feeName: formData?.feeName,
          feeType: formData?.feeType,
          feeValue: Number(formData?.feeValue),
          currency: formData?.currency,
          description: formData?.description,
        };

        await apiCallUpdateAdminProcessingFee(param);

      } else {

        const param = {
          feeName: formData?.feeName,
          feeType: formData?.feeType,
          feeValue: Number(formData?.feeValue),
          currency: formData?.currency,
          description: formData?.description,
        };

        await apiCallAddAdminProcessingFee(param);
      }

      setAddEditModal(false);

      fetchProcessingFeeList();

    } catch (error) {

      console.log("handleSubmit Error :", error);

    } finally {

      dispatch(setLoadingFalse());
    }
  };

  useEffect(() => {
    fetchProcessingFeeList();
  }, []);

  return (
    <div>
      <Header name={'PlatformSetting'} />
      <div className="Event-custom-style">

        <div className="lastWeekEndDiv Event-AlignSelf-stretch">

          {/* HEADER */}
          <div
            className="user_title event-flex-container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >

            <div>
              Platform Settings
            </div>

            <button
              onClick={handleAddClick}
              style={{
                backgroundColor: Colors.mainBlue,
                color: "#fff",
                border: "none",
                padding: "10px 15px",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              + Add Fee
            </button>

          </div>

          <div className="transparentWhite">

            {/* TABLE HEADER */}
            <nav className="grid-cols grid_7 fontSize16WithoutFlex transparentWhite-padding">

              <div style={{ width: "20%" }} className="user_name">
                Fee Name
              </div>

              <div style={{ width: "15%" }} className="user_name">
                Fee Type
              </div>

              <div style={{ width: "15%" }} className="user_name">
                Fee Value
              </div>

              <div style={{ width: "15%" }} className="user_name">
                Currency
              </div>

              <div style={{ width: "10%" }} className="user_name">
                Edit
              </div>

              <div style={{ width: "15%" }} className="user_name">
                Status
              </div>

            </nav>

            {/* LIST */}
            {
              processingFeeList?.map((item, index) => {

                return (

                  <div
                    key={index}
                    className="grid-cols grid_7 fontSize16WithoutFlex transparentWhite-padding"
                    style={{
                      borderTop: "1px solid rgba(255,255,255,0.1)",
                      padding: "15px 10px",
                    }}
                  >

                    <div style={{ width: "20%" }}>
                      {item?.feeName}
                    </div>

                    <div style={{ width: "15%" }}>
                      {item?.feeType}
                    </div>

                    <div style={{ width: "15%" }}>
                      {
                        item?.feeType === "percentage"
                          ? `${item?.feeValue}%`
                          : `$${item?.feeValue}`
                      }
                    </div>

                    <div style={{ width: "15%" }}>
                      {item?.currency}
                    </div>

                    {/* EDIT */}
                    <div style={{ width: "10%" }}>
                      <img
                        src={Icons.edit}
                        onClick={() => handleEditClick(item)}
                        className="edit-button pointer"
                        alt="edit"
                      />
                    </div>

                    {/* STATUS */}
                    <div style={{ width: "15%" }} className="user_Status user_name pointer">
                      <button
                        onClick={() => handleToggleStatus(item)}
                        className="button"
                        style={{
                          cursor: "pointer",
                          backgroundColor: item?.isActive
                            ? Colors.mainGreen01
                            : Colors.mainRed01,
                          color: item?.isActive
                            ? Colors.darkGreen
                            : Colors.darkRed,
                        }}
                      >
                        {
                          item?.isActive
                            ? "Active"
                            : "Inactive"
                        }
                      </button>
                    </div>

                  </div>
                );
              })
            }

          </div>

        </div>

      </div>

      {/* EMPTY DATA */}
      {
        processingFeeList?.length === 0 &&
        !isLoading && (
          <div className="empty-centered">
            <EmptyData />
          </div>
        )
      }

      {/* ADD / EDIT MODAL */}
      {
        addEditModal && (

          <div className="processing-fee-modal">

            <div className="processing-fee-modal-content">

              <span
                className="processing-fee-close"
                onClick={() => setAddEditModal(false)}
              >
                &times;
              </span>

              <div className="processing-fee-title">
                {
                  isEdit
                    ? "Update Processing Fee"
                    : "Add Processing Fee"
                }
              </div>

              {/* FEE NAME */}
              <div className="processing-fee-group">

                <label className="processing-fee-label">
                  Fee Name
                </label>

                <input
                  type="text"
                  placeholder="Enter fee name"
                  name="feeName"
                  value={formData?.feeName}
                  onChange={handleInputChange}
                  className="processing-fee-input"
                />

              </div>

              {/* FEE TYPE */}
              <div className="processing-fee-group">

                <label className="processing-fee-label">
                  Fee Type
                </label>

                <select
                  name="feeType"
                  value={formData?.feeType}
                  onChange={handleInputChange}
                  className="processing-fee-select"
                >
                  <option value="fixed">
                    Fixed
                  </option>

                  <option value="percentage">
                    Percentage
                  </option>

                </select>

              </div>

              {/* FEE VALUE */}
              <div className="processing-fee-group">

                <label className="processing-fee-label">
                  Fee Value
                </label>

                <input
                  type="number"
                  placeholder="Enter fee value"
                  name="feeValue"
                  value={formData?.feeValue}
                  onChange={handleInputChange}
                  className="processing-fee-input"
                />

              </div>

              {/* CURRENCY */}
              <div className="processing-fee-group">

                <label className="processing-fee-label">
                  Currency
                </label>

                <input
                  type="text"
                  placeholder="Enter currency"
                  name="currency"
                  value={formData?.currency}
                  onChange={handleInputChange}
                  className="processing-fee-input"
                />

              </div>

              {/* DESCRIPTION */}
              <div className="processing-fee-group">

                <label className="processing-fee-label">
                  Description
                </label>

                <textarea
                  placeholder="Enter description"
                  name="description"
                  value={formData?.description}
                  onChange={handleInputChange}
                  className="processing-fee-textarea"
                />

              </div>

              <button
                className="processing-fee-btn"
                onClick={handleSubmit}
              >
                {
                  isEdit
                    ? "Update"
                    : "Save"
                }
              </button>

            </div>

          </div>
        )
      }

    </div>
  );
};

export default PlatformSetting;